import { MenuContext } from './Menu';
import { forwardRef, useContext } from 'react';
import { useFloatingTree, useListItem, useMergeRefs } from '@floating-ui/react';
import * as React from 'react';
import { styled } from '@mui/material/styles';
import { jsx as _jsx } from "react/jsx-runtime";
const resolveFontPaddingSize = size => {
  const map = {
    small: {
      fontSize: '14px',
      lineHeight: '130%',
      padding: '7px 16px'
    },
    sm: {
      fontSize: '14px',
      lineHeight: '130%',
      padding: '7px 16px'
    },
    medium: {
      fontSize: '16px',
      lineHeight: '125%',
      padding: '10px 16px'
    },
    md: {
      fontSize: '16px',
      lineHeight: '125%',
      padding: '10px 16px'
    },
    large: {
      fontSize: '20px',
      lineHeight: '120%',
      padding: '12px 16px'
    },
    lg: {
      fontSize: '20px',
      lineHeight: '120%',
      padding: '12px 16px'
    }
  };
  return map[size || 'medium'];
};
const resolveDivider = (divider, theme) => {
  if (divider) {
    return {
      borderBottom: `1px solid ${theme.tokens.SemColorBorderMuted}`,
      borderBottomRightRadius: '0',
      borderBottomLeftRadius: '0'
    };
  }
  return {};
};
const StyledButton = styled('button')(_ref => {
  let {
    theme,
    size,
    disabled,
    divider
  } = _ref;
  return {
    display: 'flex',
    gap: '8px',
    justifyContent: 'flex-start',
    alignItems: 'center',
    outline: '0',
    border: '0',
    borderRadius: '4px',
    color: disabled ? theme.tokens.SemColorOnSurfaceInteractiveDisabled : theme.tokens.SemColorOnSurfaceInteractiveRest,
    backgroundColor: theme.tokens.SemColorSurfaceDefault,
    fontFamily: theme.tokens.SemTypeFontBody,
    ...resolveFontPaddingSize(size),
    ':focus': {
      backgroundColor: theme.tokens.SemColorSurfaceInteractiveHover
    },
    textAlign: 'left',
    ...resolveDivider(divider, theme),
    cursor: disabled ? 'not-allowed' : 'pointer'
  };
});
export const MenuItem = /*#__PURE__*/forwardRef((_ref2, forwardedRef) => {
  let {
    children,
    disabled,
    label,
    ...props
  } = _ref2;
  const menu = useContext(MenuContext);
  const item = useListItem({
    label: disabled ? null : label
  });
  const tree = useFloatingTree();
  const isActive = item.index === menu.activeIndex;
  return /*#__PURE__*/_jsx(StyledButton, {
    ...props,
    ref: useMergeRefs([item.ref, forwardedRef]),
    type: "button",
    role: "menuitem",
    className: "ids-menu-item",
    tabIndex: isActive ? 0 : -1,
    disabled: disabled,
    ...menu.getItemProps({
      onClick(event) {
        props.onClick?.(event);
        tree?.events.emit('click');
      },
      onFocus(event) {
        props.onFocus?.(event);
      }
    }),
    children: children
  });
});
MenuItem.displayName = 'MenuItem';